export default __webpack_public_path__ + "static/media/list_main_9_1.d5611b26.png";